import $ from "jquery";
globalThis.$ = $;
globalThis.jQuery = $;
